/* unplugin-vue-components disabled */import { render } from "./CollectUserFace.vue?vue&type=template&id=46218d10&scoped=true"
import script from "./CollectUserFace.vue?vue&type=script&lang=js"
export * from "./CollectUserFace.vue?vue&type=script&lang=js"

import "./CollectUserFace.vue?vue&type=style&index=0&id=46218d10&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46218d10"]])

export default __exports__